
import Vue from "vue";
import {mapState} from 'vuex'
import {ObjectUtils} from "~/assets/utils/ObjectUtils";

export default Vue.extend({
	name: 'Navbar',
	computed: {
		...mapState(['idgroup', 'navigation', 'nav_slot']),
		hasMotor(): boolean {
			return Array.isArray(this.navigation?.motor) && this.navigation.motor.length > 0;
		},
		hasHome(): boolean {
			return Array.isArray(this.navigation?.home) && this.navigation.home.length > 0;
		}
	},
	data: () => ({
		motorgroup: {},
		homegroup: {},
		isSlot: false
	}),
	methods: {
		setSlot() {
			let route = this.$route.path
			this.isSlot = route === '/motor/motor_dash' || route === '/home/home_dash';
		}
	},
	mounted() {
		/**
		 * @author @Simo mailto:simoneolivieri@kubepartners.com
		 * @description //retrive nagivation array from store and groupby domain
		 * @date 09:55 18/04/23
		 * @param mapState(['idgroup','navigation'])
		 * @return groupByKey
		 **/
		const motorNav = Array.isArray(this.navigation['motor']) ? this.navigation['motor'] : [];
		const homeNav = Array.isArray(this.navigation['home']) ? this.navigation['home'] : [];
		this.motorgroup = motorNav.length ? ObjectUtils.groupByKey(motorNav, 'idgroup') : {};
		this.homegroup = homeNav.length ? ObjectUtils.groupByKey(homeNav, 'idgroup') : {};
		this.setSlot()
		// console.log(this.motorgroup)
		// console.log(this.homegroup)
	}
})
